import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";

export const LoadingFallback = () => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/loading.json`)
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch((err) => console.error("Error loading animation:", err));
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", backgroundColor: "white" }}>
      {animationData ? (
        <Lottie animationData={animationData} loop={true} style={{ width: 150, height: 150 }} />
      ) : null}
    </div>
  );
};
